import {Component, Input, OnInit} from '@angular/core';
import {
    aggregateHardawareDetailDevice, arrayIsSet,
    isNotNullOrUndefined,
    sensorDataType
} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-vertical-box-element',
    templateUrl: './vertical-box-element.component.html',
    styleUrls: ['./vertical-box-element.component.scss'],
    standalone: false
})
export class VerticalBoxElementComponent implements OnInit {
    @Input()
    device: aggregateHardawareDetailDevice | undefined;
    @Input()
    selected: boolean = false;
    @Input()
    disable: boolean = false;

    allSensorDataType = sensorDataType;

    constructor() {
    }

    ngOnInit() {
    }


    addPhoto(event: Event) {
        event.stopPropagation();
    }

    public indexData = 0;

    get sensorDataType(): string {
        if (isNotNullOrUndefined(this.device) && isNotNullOrUndefined(this.device?.sensorDataTypes)) {
            return this.device?.sensorDataTypes[this.indexData]!;
        } else {
            return this.allSensorDataType.powerConsuption
        }
    }


    getSensorDataClass(device: aggregateHardawareDetailDevice, indexData: number): string | undefined {
        let cssClass;
        if (isNotNullOrUndefined(device) && arrayIsSet(device?.sensorDataTypes) && device.sensorDataTypes[indexData] != null) {
            const type = device.sensorDataTypes[indexData];
            if (type === sensorDataType.powerConsuption) {
                cssClass = 'background-color-yellow';
            } else if (type === sensorDataType.powerProduction) {
                cssClass = 'background-color-purple';
            } else if (type === sensorDataType.batteryOutput) {
                cssClass = 'background-color-verdeBlue';
            } else if (type === sensorDataType.batteryOutput) {
                cssClass = 'background-color-verdeBlue';
            } else if (type === sensorDataType.networkEnergySold) {
                cssClass = 'background-color-cyan';
            } else if (type === sensorDataType.networkEnergyBought) {
                cssClass = 'background-color-orange';
            }
        }
        return cssClass
    }

    getSensorDataTraduction(device: aggregateHardawareDetailDevice, indexData: number): string {
        let traduction = '';
        if (isNotNullOrUndefined(device) && arrayIsSet(device?.sensorDataTypes) && device.sensorDataTypes[indexData] != null) {
            const type = device.sensorDataTypes[indexData];
            traduction = 'unitOfMeasurement.' + type + '.traduction';
        }
        return traduction
    }

    getSensorDataValuePredicate(device: aggregateHardawareDetailDevice, indexData: number): number {
        if (isNotNullOrUndefined(device) && isNotNullOrUndefined(device?.sensorDataValues)) {
            return device?.sensorDataValues[indexData]!;
        } else {
            return 0
        }
    }


    getDifferenceHourWithNowPredicate(device: aggregateHardawareDetailDevice,indexData:number): number {
        if (isNotNullOrUndefined(device) && arrayIsSet(device?.sensorDataDates) && isNotNullOrUndefined(device?.sensorDataDates[indexData])) {
            const differenceWithNow = Date.now() - device?.sensorDataDates[indexData]!.getTime()!;
            const differenceH = Math.round(differenceWithNow / 1000 / 3600);
            return differenceH;
        } else {
            return 0
        }
    }

    getSensorDataTypesPredicate(device: aggregateHardawareDetailDevice) {
        if (arrayIsSet(device.sensorDataTypes)) {
            return device.sensorDataTypes.map((type, index) => {
                return {
                    value: index,
                    traduction: 'unitOfMeasurement.' + type + '.traduction'
                }
            })
        } else {
            return;
        }

    }

    setIndex(index: number) {
        this.indexData = index;
    }
}
